import {injectable, inject} from "tsyringe";
import { Customer } from "$src/domain/customers/Customer";
import type { ICustomerRepository } from "$src/domain/customers/ICustomerRepository";
import { ICustomerService } from "$src/domain/customers/ICustomerService";
import { ProjectSummary } from "$src/domain/projects/ProjectSummary";
import { PagedResult } from "$src/domain/core/PagedResult";
import { CustomerSummary } from "$src/domain/customers/CustomerSummary";


@injectable()
export class CustomerService implements ICustomerService {

    private customerRepository: ICustomerRepository;

    constructor(@inject("ICustomerRepository") customerRepository: ICustomerRepository) {
        this.customerRepository = customerRepository;
    }
    
    async getCustomerById(groupStoreId: string, customerId: number): Promise<Customer> {
        return await this.customerRepository.getCustomerById(groupStoreId, customerId);
    }

    async getProjectsByCustomerId(groupStoreId: string, customerId: string, pageNumber: number, pageSize: number): Promise<PagedResult<ProjectSummary>> {
        return await this.customerRepository.getProjectsByCustomerId(groupStoreId, customerId, pageNumber, pageSize);
    }

    async getCustomersByRecentProjects(groupStoreId: string, pattern: string, pageNumber: number, pageSize: number): Promise<PagedResult<CustomerSummary>> {

        return await this.customerRepository.getCustomersByRecentProjects(groupStoreId, pattern, pageNumber, pageSize);
    }
}
